import React from "react";
import "./Managerholiday.css";

export default function HolidayCalendarUser() {
  const holidays = [
    { date: "22.03.2023", day: "Wednesday", name: "Ugadi" },
    { date: "14.04.2023", day: "Friday", name: "Ambedkar Jayanti" },
    { date: "01.05.2023", day: "Monday", name: "Labor Day" },
    { date: "15.08.2023", day: "Tuesday", name: "Independence Day" },
    { date: "02.10.2023", day: "Monday", name: "Gandhi Jayanti" },
  ];

  return (
    <div className="hc-user-wrapper">
      <div className="hc-user-card">
        <div className="hc-user-header">
          <h2>HOLIDAY CALENDAR 2025–26</h2>
          <p>Official holidays applicable for all employees</p>
        </div>

        <div className="hc-user-table-wrap">
          <table className="hc-user-table">
            <thead>
              <tr>
                <th>S No.</th>
                <th>Date</th>
                <th>Day</th>
                <th>Holiday</th>
              </tr>
            </thead>
            <tbody>
              {holidays.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.day}</td>
                  <td className="hc-holiday-name">{item.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
